import { render, staticRenderFns } from "./-Sidebar.vue?vue&type=template&id=edbe35d8&scoped=true&"
import script from "./-Sidebar.vue?vue&type=script&lang=js&"
export * from "./-Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./-Sidebar.vue?vue&type=style&index=0&id=edbe35d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbe35d8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/SvgIcon.vue').default,LinkTo: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/LinkTo.vue').default})
